/**
 * PublicHolidayService
 * Cross-cutting catalogue. Read endpoints are public (no auth); admin
 * mutations require Admin role with System.Admin permission server-side.
 * Route: api/publicholidays
 */
import { CrudService } from '../base/CrudService';
export class PublicHolidayService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PublicHolidayService.DEFAULT_SERVICE_PATH,
            basePath: PublicHolidayService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Returns the next N upcoming holidays from today onward. */
    async getUpcoming(take = 5, country) {
        const params = { upcoming: true, take, country };
        const res = await this.http.get(this.buildUrlWithParams(undefined, params));
        return res?.data ?? [];
    }
    /** Returns holidays in a date window. Either bound is optional. */
    async getByWindow(from, to, country) {
        const params = { from, to, country };
        const res = await this.http.get(this.buildUrlWithParams(undefined, params));
        return res?.data ?? [];
    }
}
PublicHolidayService.DEFAULT_SERVICE_PATH = 'system';
PublicHolidayService.BASE_PATH = 'api/publicholidays';
//# sourceMappingURL=PublicHolidayService.js.map